<div class="search-field">
    <input
        type="search"
        [attr.data-uiid]="dataUiid + '-search-input'"
        placeholder="Search..."
        [(ngModel)]="searchValue"
    />
    <mat-icon>search</mat-icon>
</div>
<div class="item-list" [attr.data-uiid]="dataUiid">
    @for (item of filterList(selectableList); track $index) {
        @if ($index > 0) {
            <div class="list-item-divider">&nbsp;</div>
        }
        <div
            class="list-item"
            [class.selected]="selectedItems.includes(item.id)"
            [attr.data-uiid]="dataUiid + '-' + item.id"
            (click)="toggleItem(item.id)"
        >
            <div class="list-item-details">
                <span class="list-item-name">{{ item.name }}</span>
            </div>
        </div>
    }
    @if (filterList(selectableList).length === 0) {
        <div class="no-items">No items selected</div>
    }
</div>
